import React, {useState, useEffect, useCallback} from "react";
import {BottomScrollListener} from "react-bottom-scroll-listener";
import I18n from 'i18n.js.erb'
import {
  DEFAULT_PER_PAGE_PARAM,
  MEDIUM_DEBOUNCE_TIME,
  pluralize, titleize
} from "../../utils/utils";
import ErrorModal from "./ErrorModal";
import InvoicesList from "./InvoicesList";
import {debounce} from "lodash";
import {Expander} from "./IndexSubmissionLists";




const IndexInvoices = ({
    initial_invoices,
    states,
    sorting_options,
    userId,
    isSuperMiddleman
  }) => {

  const initialInvoices = JSON.parse(initial_invoices);
  const [initCompleted, setInitCompleted] = useState(false)
  const [invoices, setInvoices] = useState([]);
  const [invoicesCount, setInvoicesCount] = useState(0);
  const initialFilters = {
    number: null, state: null, sort_by: null, sorting_direction: 'desc'
  }
  const [filters, setFilters] = useState(initialFilters)
  const [filtersEnabled, setFiltersEnabled] = useState(window.innerWidth > 768);
  const [expandAll, setExpandAll] = useState(null);
  const [page, setPage] = useState(1);
  const [hasLoadedAllInvoices, setHasLoadedAllInvoices] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false)
  const [invoicesAnimationDivider, setInvoicesAnimationDivider ] = useState(Number.MAX_SAFE_INTEGER);


  useEffect(() => {
    if (initCompleted && invoices.length === 0) {
      getInvoices()
    }
  }, [invoices]);

  useEffect(() => {
    if (!initCompleted) {
      setInitCompleted(true)
      appendInvoices(initialInvoices.invoices)
      setInvoicesCount(initialInvoices.invoices_count)
    }
  }, []);

  useEffect(() => {
    if (initCompleted) {
      debouncedUpdateFilters();
      return debouncedUpdateFilters.cancel;
    }
  }, [filters.number, debouncedUpdateFilters]);


  // Funzione che permette di ottenere dal server nuove fatture da renderizzare sull'interfaccia grafica
  const getInvoices = () => {
    let url = `/users/${userId}/invoices.json?page=${page}&per_page=${DEFAULT_PER_PAGE_PARAM}`
    Object.entries(filters).forEach(([fieldName, fieldValue]) => {
      if (fieldValue !== null)
        url += `&${fieldName}=${fieldValue}`
      else {
        if (fieldName === 'sort_by')
          url += `&${fieldName}=id`
        if (fieldName === 'sorting_direction')
          url += `&${fieldName}=desc`
      }
    })

    if (!hasLoadedAllInvoices) {
      setInvoicesAnimationDivider(DEFAULT_PER_PAGE_PARAM);
      fetch(url, {
        method: 'GET'
      })
        .then(response => response.json())
        .then((data) => {
          setLoading(false);
          if (expandAll) {
            const newInvoices = data.invoices.map(i => {
              const newInvoice = { ...i };
              newInvoice['display_content'] = expandAll;
              return newInvoice;
            })
            appendInvoices(newInvoice);
          } else {
            appendInvoices(data.invoices);
          }
          setInvoicesCount(data.invoices_count)
        })
        .catch((error) => {
          console.error("ERROR:", error);
          setShowErrorModal(true);
        });
    }
  }


  // Funzione che permette di concatenare nuove fatture ottenute del server all'array che contiene tutti le
  // fatture da mostrare sull'interfaccia grafica all'utente
  const appendInvoices = (newInvoices) => {
    setInvoices(invoices.concat(newInvoices));
    setPage(page + 1);
    if (newInvoices.length < DEFAULT_PER_PAGE_PARAM)
      setHasLoadedAllInvoices(true)
  }


  // Funzione che permette di ottenere dal server le fatture dell'utente che matchano con i filtri
  // di ricerca da lui specificati sull'interfaccia grafica
  const getInvoicesByMatchingFilters = (filter, value) => {
    const newFilters = {...filters}
    newFilters[filter] = value;
    updateFilters(newFilters)
  }


  // Funzione che aggiorna i filtri di ricerca delle fatture specificati dall'utente sull'interfaccia grafica
  // e rilancia la ricerca sulle fatture che matchano con i nuovi filtri specificati
  const updateFilters = (newFilters) => {
    setFilters(newFilters);
    setLoading(true);
    setPage(1);
    setHasLoadedAllInvoices(false);
    setInvoices([]);
  }


  //Funzione che esegue l'update debouncato del filtro di ricerca delle fatture per numero
  const debouncedUpdateFilters = useCallback(
    debounce(() => updateFilters(filters), MEDIUM_DEBOUNCE_TIME),
    [filters.number]
  );


  //Funzione che setta il nuovo filtro di ricerca delle fatture per numero
  function onChangeDebouncedFilterHandler(key, value) {
    const newFilters = {...filters}
    newFilters[key] = value;
    setFilters(newFilters)
  }


  // Funzione che aggiorna tutte le fatture renderizzate sull'interfaccia grafica in corrispondenza
  // di un determinato parametro
  const handleChangeAllInvoices = (key, value) => {
    let newInvoices = invoices.map((s) => {
      const newInvoice = { ...s };
      newInvoice[key] = value;
      return newInvoice;
    });
    setInvoices(newInvoices)
  }


  // Funzione che gestisce l'espansione / compattamento di tutte le fatture renderizzate sull'interfaccia grafica
  const handleExpandAll = () => {
    setExpandAll(!expandAll);
    handleChangeAllInvoices('display_content', !expandAll);
  }



  
  

  return (
    <React.Fragment>
      <div>
        <div>
          {/*  HEADER DELLA PAGINA */}
          <div className="row d-block justify-content-center text-center bg-aig-gradient w-100 m-0 color-white py-4 border-bottom-radius-20px px-3 mb-5">
            <div>
              <h2><b>{I18n.t("js.indexInvoices.myInvoices")}</b></h2>
            </div>
          </div>




          <div id="submission_lists_header_container">
            {/*  SEZIONE DEDICATA AI FILTRI DELLA PAGINA */}
            <div className="row mx-0 br-8px border-aiG-light-gray-imp bg-aiG-gray3-imp">
              <div className="col-12">
                <div className="row d-flex justify-content-between px-3 py-2">
                  <div className="w-50">
                    <div className="d-flex align-items-center justify-content-start text-left cursor-pointer"
                         onClick={(e) => setFiltersEnabled(!filtersEnabled)}>
                      <b>{I18n.t('js.filters.filters')}</b>
                      <img src={`/images/icons/black/arrow-${filtersEnabled ? 'up' : 'down'}.svg`} className="cursor-pointer ml-2"
                           alt="" width="10" height="10"
                      />
                    </div>
                  </div>

                  <div className="w-50">
                    <div className="d-flex align-items-center justify-content-end blue-label text-right cursor-pointer"
                         onClick={(e) => updateFilters(initialFilters)}>
                      <img src="/images/icons/blue/refresh.svg" className="mr-2" id="reset"
                           alt="" width="15" height="15"
                      />
                      {I18n.t('js.filters.cancelFilters')}
                    </div>
                  </div>
                </div>

                <div className={`row slide-animation-container slide-${filtersEnabled ? 'down' : 'up'}`}>
                  <hr className="separator my-0 w-100" />

                  <div className="col-12 pr-0">
                    <div className="row w-100 py-2">
                      <div className="col-6 col-md-4 col-lg-3 mb-2 py-1">
                        <p className="mb-0 filter-label">{I18n.t('js.filters.placeholderInvoiceNumber')}</p>
                        <input
                          type="text"
                          value={filters.number ? filters.number : ""}
                          className={`form-control filter-input ${filters.number ? 'selected-label' : 'border-none'}`}
                          onChange={(e) => onChangeDebouncedFilterHandler('number', e.target.value)}
                          name="number_filter"
                          id="number_filter"
                        />
                      </div>

                      <div className="col-6 col-md-4 col-lg-3 mb-2 py-1">
                        <p className="mb-0 filter-label">{I18n.t('js.filters.state')}</p>
                        <select
                          className={`form-control filter-input ${filters.state ? 'selected-label' : 'border-none'} pl-2`}
                          value={filters.state ? filters.state : ""}
                          name="state_filter"
                          id="state_filter"
                          onChange={(e) => getInvoicesByMatchingFilters('state', e.target.value)}
                        >
                          <option value={""}></option>
                          {states.map(state => {
                            return <option value={state} key={state}>
                              {I18n.t(`js.indexInvoices.states.${state}`)}
                            </option>
                          })}
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>


            {/*  SEZIONE DEDICATA ALLA GESTIONE DEI RISULTATI RENDERIZZATI SULLA PAGINA */}
            <div
              className="mt-4 mb-3 d-block d-sm-flex justify-content-start justify-content-sm-between align-items-center border-bottom-2px-lightgray3">
              <div className="d-flex justify-content-between align-items-center pb-3 px-0">
                <div className="align-items-center">
                  <b>{invoicesCount}</b>&nbsp;
                  {pluralize(invoicesCount, 'indexInvoices.invoice').toLowerCase()}&nbsp;
                </div>

                {

                  initCompleted && invoicesCount > 0 &&
                    <div className="d-flex d-sm-none align-items-center">
                      <Expander
                        expandAll={expandAll}
                        handleExpandAll={handleExpandAll}
                      />
                    </div>
                }
              </div>

              {
                initCompleted && invoicesCount > 0 &&
                <div className="d-flex justify-content-start justify-content-sm-end pb-3 px-0">
                  <div className="d-none d-sm-flex align-items-center">
                    <Expander
                      expandAll={expandAll}
                      handleExpandAll={handleExpandAll}
                    />
                  </div>

                  <select
                    className={`form-control minW-165px gray-label ${filters.sort_by ? 'selected-label' : ''}`}
                    name="sort_by"
                    id="sort_by"
                    value={filters.sort_by ? filters.sort_by : ''}
                    onChange={(e) => getInvoicesByMatchingFilters('sort_by', e.target.value)}>
                    <option value="" disabled hidden>{I18n.t('js.indexSubmissionListsPage.sortBy')}</option>
                    {sorting_options.filter(option => option.value).map(option => {
                      return <option value={option.value} key={option.value}>{I18n.t(option.locale)}</option>
                    })}
                  </select>

                  {
                    filters.sort_by &&
                    <div className="d-flex justify-content-center align-items-center px-0 cursor-pointer ml-3"
                         onClick={(e) => getInvoicesByMatchingFilters('sorting_direction', filters.sorting_direction === 'desc' ? 'asc' : 'desc')}>
                      <div className="d-flex justify-content-center align-items-center blue-label minW-38px">
                        <p className="my-0 mr-2">
                          {filters.sorting_direction === 'desc' ? '↓' : '↑'}
                        </p>
                        <p className="my-0">
                          {I18n.t(`js.filters.sort.${filters.sorting_direction}endingSuperCompact`)}
                        </p>
                      </div>
                    </div>
                  }
                </div>
              }
            </div>
          </div>


          {/*  SEZIONE DEDICATA ALL'ELENCO DI TUTTE LE FATTURE */}
          <div id="submission_lists_header_container">
            {
              loading ?
                <div className="d-flex justify-content-center my-5">
                  <div className="d-flex align-items-center text-intense-blue text-weight-500">
                    <div className="spinner-border" role="status"/>
                    <b className="ml-2">{I18n.t('js.indexInvoices.loading')}</b>
                  </div>
                </div>
              :
                invoices.length > 0 ?
                  <BottomScrollListener onBottom={getInvoices}>
                    <InvoicesList
                      invoices={invoices}
                      setInvoices={setInvoices}
                      invoicesAnimationDivider={invoicesAnimationDivider}
                      isSuperMiddleman={isSuperMiddleman}
                    />


                    {
                      !hasLoadedAllInvoices && invoices.length > 0 &&
                        <div className="d-flex justify-content-center mb-5  mt-0">
                          <div className="d-flex align-items-center text-intense-blue text-weight-500">
                            <div className="spinner-border" role="status"/>
                            <b className="ml-2">{I18n.t('js.indexInvoices.loading')}</b>
                          </div>
                        </div>
                    }
                  </BottomScrollListener>
                  :
                  <div className="d-flex justify-content-center">
                    <div className="d-flex align-items-center text-muted ml-md-3 mr-md-3 mt-md-4 text-center text-space">
                      <b className="ml-2">{I18n.t('js.filters.noResultsFoundInvoice')}</b>
                    </div>
                  </div>
            }
          </div>
        </div>
      </div>


      <ErrorModal
        showErrorModal={showErrorModal}
        setShowErrorModal={setShowErrorModal}
      />
    </React.Fragment>
  );
};

export default IndexInvoices;